import { Button, Grid, Stack, Typography } from "@mui/material";
import { useGetMerchantQuery } from "../../../redux/commonRTK";
import { getMerchant } from "../../../helpers/ReduxHelpers";
import { FormSkeleton } from "../../../common/Skeletons";
import { RHFSearchableSelectField } from "../../../common/hook-form";
import _ from "lodash";
import { addressString } from "../../../helpers/UtilityHelper";
import React from "react";
import { useFormContext } from "react-hook-form";

function PickupLocationRVP({ setActiveStep }) {
    const merchant = getMerchant();
    const { trigger } = useFormContext()

    const { data, isLoading, isFetching } = useGetMerchantQuery({ id: merchant.id })

    const pickupLocations = data?.pickup_details || [];
    const pickupLocationOptions = _(pickupLocations)
        .filter({ status: 'ACTIVE', address_type: 'PICKUP' })
        .map((loc) => ({
            value: loc.id,
            label: addressString(loc)
        })).value()

    if (isLoading || isFetching) {
        return <FormSkeleton />
    }

    const onNextHandler = async () => {
        const status = await trigger(['pickupLocation']);
        if (status) {
            setActiveStep(2)
        }
    }

    const onKeyPressHandler = (e) => {
        if (e.charCode === 13) {
            onNextHandler();
        }
    }

    return (
        <Grid container spacing={3}>
            <Grid item xs={12} sx={{ mb: 3 }}>
                <RHFSearchableSelectField
                    options={pickupLocationOptions}
                    width="100%"
                    placeholder="Please Select Drop Location"
                    name="pickupLocation"
                    onKeyPress={onKeyPressHandler}
                    autoFocus={true}
                />
                <Typography variant="body2">
                    If Drop Location is not present then create a new
                    <Button sx={{ py: 0, textTransform: 'none' }} target="_blank" href="/merchant-step2">
                        Drop Location
                    </Button>
                </Typography>
            </Grid>

            <Grid item xs={12}>
                <Stack direction="row" columnGap={1} sx={{ mt: 3 }}>
                    <Button variant="contained" size="small" color="error" onClick={() => setActiveStep(0)}>Back</Button>
                    <Button variant="contained" size="small" onClick={onNextHandler}>Next</Button>
                </Stack>
            </Grid>
        </Grid>
    )
}

export default PickupLocationRVP;